<template>
  <div v-if="wasMounted">
    <sc-field class="tooltipContainer"
      :label="schema.title"
      :message="warningMessage"
      :type="warningType">

      <sc-tooltip v-if="schema.tooltip" class="tooltipContainer__tooltip"
        type="is-light" position="is-right"
        :label="schema.tooltip">

        <sc-icon size="is-small" icon="info-circle" />
      </sc-tooltip>

      <sc-multiple-selection class="tooltipContainer__input"
        :options="schema.options" v-model="value[schema.name]" @input="onChange()" :hasActions="false" />

    </sc-field>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScField,
  ScMultipleSelection,
  ScTooltip,
  ScIcon,
} from '@intelipost-js/secure-components';

const { mapMutations } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);

export default {
  name: 'list-option-field',
  components: {
    ScField,
    ScMultipleSelection,
    ScTooltip,
    ScIcon,
  },
  props: {
    schema: {
      type: Object,
      required: true,
    },
    warehouseId: {
      type: Number,
      required: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      wasMounted: false,
      warningMessage: '',
      warningType: '',
      showWarnings: false,
    };
  },
  mounted() {
    this.value[this.schema.name] = [];
    if (this.schema.default !== undefined) {
      this.value[this.schema.name] = this.schema.default;
    }
    this.syncAppConfig();
    this.wasMounted = true;
  },
  computed: {
  },
  methods: {
    ...mapMutations([
      'setAppConfigField',
    ]),

    validate() {
      let valid = true;
      this.warningMessage = '';
      this.warningType = '';

      if (this.schema.required && !this.value[this.schema.name]) {
        valid = false;
        if (this.showWarnings) {
          this.warningMessage = 'O campo é obrigatório.';
          this.warningType = 'is-danger';
        }
      }
      return valid;
    },

    onChange() {
      this.validate();
      this.syncAppConfig();
      this.$emit('change');
    },

    syncAppConfig() {
      this.setAppConfigField({
        app_config_section: this.schema.app_config_section,
        warehouseId: this.warehouseId,
        fieldName: this.schema.name,
        fieldValue: this.value[this.schema.name],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tooltipContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  &__tooltip {
    padding-left: 5px;
  }
  &__input {
    flex-basis: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/fields/ListOptionField.vue?2cd5691c